import {useState} from 'react';
import {useMutation} from '@apollo/client';
import {Redirect} from 'react-router-dom';
import {ToastMessage} from '@core/ui/Alert';
import {Card, CardHeader} from '@core/ui/Content';
import ResponsiveContent from '@core/ui/ResponsiveContent';
import PixelConversionUrlForm from '@analytics/components/pixels/PixelConversionUrlForm';
import UPDATE_CONVERSION_URL_MUTATION from '@analytics/graphql-api/_old_mutations/UpdateConversionUrl';
import ORGANIZATION_KEY_QUERY from '@analytics/graphql-api/_old_queries/OrganizationKeyQuery';
import {ManagePixelsPixelUrlRouteProps} from '.';

export function PixelUpdateUrl({
  backPath,
  pixel,
  match: {
    params: {id},
  },
}: ManagePixelsPixelUrlRouteProps & {
  match: {params: {id: string}};
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [complete, setCompleted] = useState(false);

  const [updateConversionUrl] = useMutation(UPDATE_CONVERSION_URL_MUTATION, {
    refetchQueries: [ORGANIZATION_KEY_QUERY],
    awaitRefetchQueries: true,
  });

  const conversionUrl = pixel.conversionUrls.find((c) => c.id === id);

  const onSubmit = async (item: {
    url: string;
    action: string;
    value?: string;
    type?: string;
    category?: string;
  }) => {
    setError(false);
    setLoading(true);
    try {
      const data = await updateConversionUrl({
        variables: {
          input: {
            conversionUrlId: conversionUrl.id,
            ...item,
          },
        },
      });
      if (data) {
        setCompleted(true);
      }
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  };

  const onCancel = () => {
    setError(false);
    setCompleted(true);
  };

  if ((!conversionUrl || complete) && !error) {
    return <Redirect to={backPath} />;
  }

  return (
    <ResponsiveContent containerSize='medium'>
      <CardHeader backPath={backPath}>Add Conversion URL</CardHeader>
      <Card>
        {error && (
          <ToastMessage
            rules={() => ({margin: '0 0 1.5rem'})}
            alertType='error'>
            Network Error. Please Try again.
          </ToastMessage>
        )}
        <PixelConversionUrlForm
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          updateItem={conversionUrl}
        />
      </Card>
    </ResponsiveContent>
  );
}
